import React, { useState, useEffect } from "react";
import useFitText from "use-fit-text";
import {
  BoatBadge,
  BowBadge,
  DuckBadge,
  Pumpkins,
  ThreeHearts,
  Wreath,
  EyeLids,
  TennRackets,
  Clubs,
  Paddles,
  HeartEyes,
  PonceSvg,
} from "./icons";
import iconsTabFonts from "./iconTabFonts";

const EmbPreview = ({ properties, size = 41, customClass = "" }) => {
  const [loading, setLoading] = useState(true);
  const { fontSize, ref } = useFitText({
    maxFontSize: 500,
    minFontSize: 1,
    onFinish: () => setLoading(false),
  });

  const embroideryColor = properties?.["Embroidery Color"] || "";
  const embroideryStyle = properties?.["Embroidery Style"] || "";
  var embroideryText = (properties?.["Embroidery Text"] || "").trim();

  if (embroideryText === "Icon") {
    embroideryText = "";
  }

  useEffect(() => {
    setLoading(false);
  }, [embroideryText, embroideryStyle]);

  const RenderIcon = ({ icon, iconClass }) => {
    const Icon = icon;
    return Icon && <Icon elClass={iconClass} showLabel={false} />;
  };
  return (
    <div
      className={`litem__img-embpreview-wrap litem__img-embpreview-wrap--${customClass} litem__img-embpreview-wrap--loading-${loading} ${embroideryColor
        .toLowerCase()
        .replace(/\s/g, "")}`}
    >
      <div
        className={`litem__img-embpreview embroidery__preview-text--${embroideryStyle.toLowerCase()} embroidery__preview-text--${embroideryColor
          .toLowerCase()
          .replace(/\s/g, "")}`}
        style={{ fontSize, height: size, width: size }}
        ref={ref}
      >
        {embroideryText === "" && (
          <div className="embroidery__preview-icon">
            {iconsTabFonts.map(
              (item) =>
                item.font === embroideryStyle && (
                  <RenderIcon
                    key={item.font}
                    icon={item.iconBadge}
                    iconClass="embroidery__font-btn__icon"
                  />
                )
            )}
          </div>
        )}

        {embroideryText !== "" &&
          [...embroideryText].map((letter, i) =>
            embroideryStyle === "Ponce" ||
            embroideryStyle === "Ponce Large" ||
            embroideryStyle === "Ponce Small" ? (
              <div key={`${i}-${letter}-wrapper`}>
                <span
                  key={`${i}-${letter}`}
                  className={`ponce_letter ${
                    letter === " " ? "spacer" : undefined
                  }`}
                >
                  {letter}
                </span>
                <PonceSvg
                  key={`${i}-${letter}-svg`}
                  elClass="ponce_svg"
                  embColor={embroideryColor}
                />
              </div>
            ) : (
              <span
                key={`${i}-${letter}`}
                className={letter === " " ? "spacer" : undefined}
              >
                {letter}
              </span>
            )
          )}
      </div>
    </div>
  );
};

export default EmbPreview;
